import { ReactNode } from 'react';

import {
  Icons,
  Typography,
  Box,
  Stack,
  colorOrToken,
  tokens,
} from '@cast/design-system';

type AgentSetupCompleteBlockProps = {
  heading: string;
  icon?: ReactNode;
  testId?: string;
  checked?: boolean;
  isNestedBlock?: boolean;
};

export const AgentSetupCompleteBlock = ({
  heading,
  icon,
  testId,
  checked = false,
  isNestedBlock = false,
}: AgentSetupCompleteBlockProps) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      gap={12}
      py={isNestedBlock ? 8 : 12}
      borderTop={
        !isNestedBlock
          ? colorOrToken('grey.100', tokens.theme.border.structural.neutral)
          : undefined
      }
      px={isNestedBlock ? 24 : 0}
      data-testid={testId}
      data-enabled={checked}
    >
      <Stack direction="row" gap={10}>
        {checked ? (
          <Icons.CheckCircle
            size={20}
            weight="fill"
            color={colorOrToken('green.500', tokens.theme.fg.status.success)}
          />
        ) : (
          <Icons.XCircle
            size={20}
            weight="fill"
            color={colorOrToken(
              'grey.400',
              tokens.theme.fg.structural.secondary
            )}
          />
        )}
        <Stack gap={2}>
          <Stack direction="row" alignItems="center" gap={8}>
            <Typography
              variant={isNestedBlock ? 'P12B' : 'P14B'}
              color={colorOrToken(
                'grey.900',
                tokens.theme.fg.structural.primary
              )}
            >
              {heading}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
      {icon && (
        <Box
          alignSelf="flex-start"
          sx={{
            svg: {
              width: 36,
              height: 36,
            },
          }}
        >
          {icon}
        </Box>
      )}
    </Stack>
  );
};
